import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoTimeOutline, IoChevronForward } from 'react-icons/io5';

const MyMeetingApplicationContainer = ({ application }) => {
    const navigate = useNavigate();

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();

        return `${year}.${month.toString().padStart(2, '0')}.${day.toString().padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };

    const handleClick = () => {
            navigate(`/app/meeting-applications/${application.id}`);
    };

    return (
        <div
            onClick={handleClick}
            className="bg-white border border-gray-200 rounded-lg p-4 mb-3 cursor-pointer active:bg-gray-50"
        >
            <div className="flex items-center justify-between">
                <div className="flex-1">
                    <h3 className="font-medium text-gray-900 mb-1">
                        {application.meetingTitle}
                    </h3>
                    <div className="flex items-center text-sm text-gray-500">
                        <IoTimeOutline size={16} className="mr-1" />
                        <span>신청일: {formatDate(application.createdAt)}</span>
                    </div>
                </div>
                <IoChevronForward size={16} className="text-gray-400" />
            </div>
        </div>
    );
};

export default MyMeetingApplicationContainer;
